const { helpers } = require("vuelidate/lib/validators");

const ref = (prop, fn) =>
  helpers.withParams({ type: "requireRef", prop }, (value, parentVm) => {
    const ref = helpers.ref(prop, this, parentVm);
    return fn(value, ref);
  });

module.exports = ref;
